<template>

    <div class="container-fluid fullheight">

        <div id="messages"></div>

        <div class="page-header clearfix h1 mt-10">
            <div class="page-header-title">
                <i class="fas fa-columns"></i>
                Production Dashboard
            </div>
            <div class="header-loading-icon">
                <loading-spinner v-if="loading"></loading-spinner>
            </div>
        </div>

        <div v-if="!isFirstLoad" class="row main-pd-row">

            <table class="table table-bordered pd-table">
                <thead>
                    <tr>
                        <th scope="col" class="th-blank" style="width: 1%;"></th>
                        <th v-for="items in work_items" scope="col" :style="thStyles">
                            <div class="pd-table-user-box">
                                <div class="pd-table-avatar">
                                    <img v-if="users[items.user_id].avatar_url" :src="users[items.user_id].avatar_url">
                                    <i v-else class="fas fa-user"></i>
                                </div>
                                <div class="pd-table-user-name">{{ users[items.user_id].name }}</div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row"><div class="row-label">To Do</div></th>
                        <td v-for="items in work_items">
                            <dash-cell
                                    :data="items.to_do || {}"
                                    type="to_do"
                                    :now="now"
                            ></dash-cell>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row"><div class="row-label">In Progress</div></th>
                        <td v-for="items in work_items">
                            <dash-cell
                                    :data="items.in_progress || {}"
                                    type="in_progress"
                                    :now="now"
                            ></dash-cell>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row"><div class="row-label">Done</div></th>
                        <td v-for="items in work_items">
                            <dash-cell
                                    :data="items.done || {}"
                                    type="done"
                                    :now="now"
                            ></dash-cell>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" class="th-blank"></th>
                        <td v-for="items in work_items">
                            <dash-progress-bar :items="items"></dash-progress-bar>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <a style="display:none;" id="toggle-full-width"></a>

    </div>

</template>

<script>

    import api from '../api';
    import Timer from './Timer.vue';
    import LoadingSpinner from './LoadingSpinner';
    import DashProgressBar from './DashProgressBar';
    import DashCell from './DashCell';
    import miniToastr from 'mini-toastr';

    export default {

        props: {},

        data: () => ({
            isFirstLoad: true,
            loading: true,
            users: null,
            work_items: null,
            now: Math.trunc((new Date()).getTime() / 1000),
        }),

        components: { Timer, miniToastr, LoadingSpinner, DashProgressBar, DashCell },

        mounted() {
            $(document).ready(function() {
                $("#toggle-full-width").click();

                miniToastr.init({
                    timeout: 3000,
                    appendTarget: document.getElementById('messages'),
                });
            });

            // counter for timers
            // window.setInterval(() => {
            //     this.now = Math.trunc((new Date()).getTime() / 1000);
            // }, 1000);

            // session keep-alive ping every 30 mins
            window.setInterval(() => {
                api.ping();
            }, 30 * 60 * 1000);
        },

        async created() {
            await this.loadDashboard();

            window.Echo.channel('production_dashboard')
                .listen('ProductionDashboardUpdated', e => {
                    console.log('ProductionDashboardUpdated');
                    this.loadDashboard();
                });
        },

        destroyed() {
            window.Echo.leaveChannel('production_dashboard');
        },

        methods: {
            loadDashboard() {
                this.loading = true;
                return api.getProductionDashboardData().then(data => {
                    this.loading = false;
                    this.isFirstLoad = false;
                    if (api.responseHasErrors(data)) return;
                    this.users = data.users;
                    this.work_items = data.work_items;
                });
            },
        },

        computed: {
            thStyles() {
                let styles = {};
                let length = Object.keys(this.work_items).length;

                if (length)
                    styles.width = Math.floor(100 / length) + '%';

                return styles;
            },
        },

    }
</script>

<style>

    .production-dashboard {
        background-color: #111214;
        height: 100%;
        width: 100%;
        -webkit-user-select: none; /* Chrome all / Safari all */
        -moz-user-select: none;   /* Firefox all */
        -ms-user-select: none;  /* IE 10+ */
        user-select: none;  /* Likely future */
    }

    .production-dashboard .ui-footer {
        display: none;
    }

    .production-dashboard .page-header {
        border: none;
    }

    .page-header-title {
        color: #8c8c8c;
        border: none;
        float: left;
        margin: 0 0 0 2px;
    }

    .page-header-title .fa,
    .page-header-title .fas {
        margin-right: 10px;
    }

    .header-loading-icon {
        display: inline-block;
        float: right;
        width: 200px;
        margin: 5px 0 0 0;
    }

    .fullheight,
    #ProductionDashboard,
    .production-dashboard .main-container {
        height: 100%;
    }

    .main-pd-row {
        height: calc(100% - 100px);
    }


    .pd-table {
        height: 100%;
        margin: 0;
    }

    .pd-table td, .pd-table th {
        border: 10px solid #111214 !important;
    }

    .pd-table tbody tr {
        height: 1%;
    }

    .pd-table td {
        padding: 0 !important;
        vertical-align: top !important;
    }

    .pd-table tbody th {
        background-color: #2a2a2a !important;
    }

    .pd-table thead th {
        height: 1px;
        padding: 0 !important;
    }

    .pd-table thead th:nth-child(2) .pd-table-user-box {
        border-top-left-radius: 20px;
    }
    .pd-table thead th:last-child .pd-table-user-box {
        border-top-right-radius: 20px;
    }

    .pd-table tbody tr:first-child th {
        border-top-left-radius: 20px;
    }
    .pd-table tbody tr:nth-last-child(2) th {
        border-bottom-left-radius: 20px;
    }

    .pd-table-user-box {
        background-color: #2a2a2a !important;
        width: 100%;
        height: 60px;
        padding: 8px 20px;
        color: #d7d7d7;
        font-size: 20px;
        font-weight: bold;
        line-height: 40px !important;
    }

    .row-label {
        transform: rotate(90deg);
        transform-origin: 5px 30px;
        white-space: nowrap;
        width: 35px;
        font-size: 22px;
        color: #d7d7d7;
        min-height: 200px;
    }

    .pd-table .th-blank {
        background: none !important;
    }

    .pd-table-avatar {
        margin: 0 auto;
        width: 100%;
        text-align: center;
    }

    .pd-table-avatar img,
    .pd-table-avatar .fa,
    .pd-table-avatar .fas {
        border-radius: 4px;
        width: 40px;
        height: 40px;
        font-size: 40px;
        color: #cfcfcf;
        display: inline-block;
        vertical-align: middle;
    }
    .pd-table-user-name {
        display: none;
        float: left;
    }

    @media (min-width:1500px) {
        .pd-table-user-name {
            display: inline-block;
        }
        .pd-table-avatar {
            margin-right: 20px;
            float: left;
            width: 40px;
        }
    }



</style>